var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8854 60.4825C66.054 60.4825 75.9185 50.6179 75.9185 38.4494C75.9185 26.2808 66.054 16.4163 53.8854 16.4163C41.7169 16.4163 31.8523 26.2808 31.8523 38.4494C31.8523 50.6179 41.7169 60.4825 53.8854 60.4825ZM53.8854 63.4825C67.7108 63.4825 78.9185 52.2748 78.9185 38.4494C78.9185 24.624 67.7108 13.4163 53.8854 13.4163C40.06 13.4163 28.8523 24.624 28.8523 38.4494C28.8523 52.2748 40.06 63.4825 53.8854 63.4825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4814 63.7899C32.5967 63.7899 14.8556 81.531 14.8556 103.416H11.8556C11.8556 79.8742 30.9398 60.7899 54.4814 60.7899C78.023 60.7899 97.1072 79.8742 97.1072 103.416H94.1072C94.1072 81.531 76.3662 63.7899 54.4814 63.7899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.669 17.6125L88.1912 34.8425L86.7458 33.4602L103.224 16.2302L104.669 17.6125Z",
    fill: "#FFE173"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0077 34.8377L78.1911 24.4331L79.6458 23.0605L89.4624 33.4652L88.0077 34.8377Z",
    fill: "#FFE173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTick);
export default __webpack_public_path__ + "static/media/user-tick.eab84fea153afdaf1f1aacc2c12b90fa.svg";
export { ForwardRef as ReactComponent };